import { Button, message } from "antd";
import { useMemo, useState } from "react";
import { AiOutlineUpload } from "react-icons/ai";
import { useNavigate } from "react-router";
import apiCall from "../../components/Api";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import UploadImages from "../../components/Common/UploadImages";
import AddButton from "../../components/Common/addButton";
import Deletepopup from "../../components/Modal/AntdDeletepopup";

const MedicineAssetsUpload = () => {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const moveAssetsPage = () => {
    navigate("/healthsy-services/order-medicines/assets");
  };

  const handleClose = () => {
    setDeleteModal({ id: "", status: false });
  };

  const handleDelete = async (id) => {
    try {
      await apiCall(`manufacturer/delete/${id}`, "DELETE", null, null);
      setDeleteModal({ id: "", status: false });
      message.success("Item deleted successfully");
    } catch (error) {
      setDeleteModal({ id: "", status: false });
      message.error("Failed to delete item");
    }
  };

  const onChangeImages = (newFileList) => {
    setFileList(newFileList);
  };

  const onRemoveImages = (file) => {
    setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      message.warning("Please select images to upload");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      fileList.forEach((file) => {
        if (file.url) {
          formData.append("images", file?.url);
        } else {
          formData.append("images", file?.originFileObj);
        }
      });

      const result = await apiCall("medicine/upload-images", "POST", formData);
      if (result.status === 200) {
        message.success("Images uploaded successfully");
        setFileList([]);
      } else {
        message.error("Failed to upload images");
      }
    } catch (error) {
      message.error("An error occurred while uploading images");
    }
    setLoading(false);
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Healthsy Services",
        link: "/healthsy-services/order-medicines/medicine-details",
      },
      {
        text: "Order Medicines",
        link: "/healthsy-services/order-medicines/assets",
      },
      {
        text: "Assets",
        link: "",
      },
    ],
    [],
  );
  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pt-1 pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={breadcrumbsList}
            />
            <div className="d-flex gap-4 align-items-center">
              <div className="bgPrimary addBtn">
                <AddButton
                  onClick={moveAssetsPage}
                  addBtn={true}
                  isIcon={false}
                  btnContent="Go to Assests Page"
                />
              </div>
            </div>
          </div>
        }
        footer={<></>}
      >
        <div className="healtharticle mb-5">
          <div className="healtharticle-container healthsyContainer">
            <UploadImages
              fileList={fileList}
              setFileList={setFileList}
              onChangeImages={onChangeImages}
              onRemoveImages={onRemoveImages}
              name={"images"}
            />
            <div className="text-center my-3 antdBtnWrapper">
              <Button
                type=""
                icon={<AiOutlineUpload />}
                loading={loading}
                onClick={handleUpload}
              >
                Upload Images
              </Button>
            </div>
          </div>
        </div>
      </MainconternLayout>

      {deleteModal.status === true && (
        <Deletepopup
          handleDelete={handleDelete}
          id={deleteModal?.id}
          isCloseModalEnable={true}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default MedicineAssetsUpload;
